module.exports = __webpack_public_path__ + "img/thankyou.7485deb9.gif";